import amex from '../../../assets/images/amex.png';
import credit from '../../../assets/images/credit.png';
import diners from '../../../assets/images/diners.png';
import discover from '../../../assets/images/discover.png';
import jcb from '../../../assets/images/jcb.png';
import mastercard from '../../../assets/images/mastercard.png';
import visa from '../../../assets/images/visa.png';

export const getPic = {
  'American Express': amex,
  'Diners Club': diners,
  Discover: discover,
  JCB: jcb,
  MasterCard: mastercard,
  Unknown: credit,
  Visa: visa
};
